const Can = props => {
  const { renderYes, renderNo } = props;

  const check = () => true;

  return check() ? renderYes() : renderNo();
};

Can.defaultProps = {
  renderYes: () => null,
  renderNo: () => null,
  dependancies: [],
};

export default Can;
